import {
  useEffect,
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import api from "../api";

export default function FacturesList() {

  const [factures, setFactures] =
    useState([]);

  const [search, setSearch] =
    useState("");

  const [filter, setFilter] =
    useState("all");

  const [page, setPage] =
    useState(1);

  const limit = 20;

  const navigate =
    useNavigate();

  useEffect(() => {
    loadFactures();
  }, []);

  // =====================
  // FETCH
  // =====================

  const loadFactures =
    async () => {

      try {

        const res =
          await api.get(
            "/factures"
          );

        setFactures(
          res.data || []
        );

      } catch (err) {

        console.error(err);

      }
    };

  // =====================
  // OPEN
  // =====================

  const openFacture =
    (id) => {

      navigate(
        `/facture/${id}`
      );
    };

  const today =
    new Date();

  // =====================
  // FILTERS
  // =====================

  const filtered =
    factures.filter(
      (f) => {

        const matchSearch = `
          ${f.numero}
          ${f.nom}
          ${f.prenom}
          ${f.appartement}
        `
          .toLowerCase()
          .includes(
            search.toLowerCase()
          );

        const date =
          new Date(
            f.date_creation
          );

        if (
          filter === "today"
        ) {

          return (
            matchSearch &&
            date.toDateString() ===
              today.toDateString()
          );
        }

        if (
          filter === "week"
        ) {

          const diff =
            (today - date) /
            (1000 *
              60 *
              60 *
              24);

          return (
            matchSearch &&
            diff <= 7
          );
        }

        return matchSearch;
      }
    );

  // =====================
  // PAGINATION
  // =====================

  const totalPages =
    Math.ceil(
      filtered.length /
        limit
    );

  const paginated =
    filtered.slice(
      (page - 1) * limit,
      page * limit
    );

  // =====================
  // STATS
  // =====================

  const total =
    filtered.reduce(
      (sum, f) =>
        sum +
        Number(
          f.montant || 0
        ),
      0
    );

  const paye =
    filtered.filter(
      (f) => {

        const montant =
          Number(
            f.montant || 0
          );

        const totalPaye =
          Number(
            f.total_paye ||
              0
          );

        const reste =
          Number(
            f.reste ??
              (montant -
                totalPaye)
          );

        return reste <= 0;
      }
    ).length;

  const resteCount =
    filtered.length -
    paye;

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 space-y-4 md:space-y-6 min-h-[100dvh] bg-gray-100">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between gap-3">

        <h2 className="text-2xl md:text-3xl font-semibold">
          Factures
        </h2>

        <input
          type="text"
          placeholder="Rechercher..."
          className="border px-4 py-3 rounded-xl w-full md:w-72 outline-none focus:ring-2 focus:ring-blue-400"
          value={search}
          onChange={(e) => {

            setSearch(
              e.target.value
            );

            setPage(1);

          }}
        />

      </div>

      {/* FILTERS */}
      <div className="flex gap-2 flex-wrap">

        <button
          onClick={() => {

            setFilter("all");

            setPage(1);

          }}
          className={`px-4 py-2 rounded-xl text-sm transition ${
            filter === "all"
              ? "bg-gray-800 text-white"
              : "bg-white hover:bg-gray-100"
          }`}
        >
          Toutes
        </button>

        <button
          onClick={() => {

            setFilter(
              "today"
            );

            setPage(1);

          }}
          className={`px-4 py-2 rounded-xl text-sm transition ${
            filter ===
            "today"
              ? "bg-blue-600 text-white"
              : "bg-white hover:bg-gray-100"
          }`}
        >
          Aujourd’hui
        </button>

        <button
          onClick={() => {

            setFilter(
              "week"
            );

            setPage(1);

          }}
          className={`px-4 py-2 rounded-xl text-sm transition ${
            filter ===
            "week"
              ? "bg-green-600 text-white"
              : "bg-white hover:bg-gray-100"
          }`}
        >
          7 jours
        </button>

      </div>

      {/* STATS */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">

        <div className="bg-white p-4 rounded-2xl shadow text-center">

          <p className="text-sm text-gray-500">
            Total
          </p>

          <p className="font-bold text-lg md:text-xl">
            {total.toLocaleString()} $
          </p>

        </div>

        <div className="bg-green-100 p-4 rounded-2xl text-center">

          <p className="text-sm">
            Payées
          </p>

          <p className="font-bold text-green-700 text-lg md:text-xl">
            {paye}
          </p>

        </div>

        <div className="bg-red-100 p-4 rounded-2xl text-center">

          <p className="text-sm">
            En attente
          </p>

          <p className="font-bold text-red-700 text-lg md:text-xl">
            {resteCount}
          </p>

        </div>

      </div>

      {/* MOBILE */}
      <div className="grid gap-3 md:hidden">

        {paginated.map(
          (f) => {

            const montant =
              Number(
                f.montant || 0
              );

            const totalPaye =
              Number(
                f.total_paye ||
                  0
              );

            const reste =
              Number(
                f.reste ??
                  (montant -
                    totalPaye)
              );

            const isPaid =
              reste <= 0;

            return (
              <div
                key={f.id}
                onClick={() =>
                  openFacture(
                    f.id
                  )
                }
                className="bg-white rounded-2xl shadow border p-4 cursor-pointer"
              >

                <div className="flex justify-between items-start gap-2">

                  <div className="font-semibold text-blue-600 break-all">
                    {f.numero}
                  </div>

                  <span
                    className={`px-2 py-1 rounded text-xs whitespace-nowrap ${
                      isPaid
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {isPaid
                      ? "PAYÉ"
                      : "RESTE"}
                  </span>

                </div>

                <div className="mt-3 text-sm break-words">
                  👤 {f.nom}{" "}
                  {f.prenom}
                </div>

                <div className="text-sm mt-1">
                  🏢{" "}
                  {
                    f.appartement
                  }
                </div>

                <div className="mt-3 text-xl font-bold">
                  {montant.toLocaleString()} $
                </div>

                <div className="text-xs text-gray-500 mt-2">
                  {f.date_creation
                    ? new Date(
                        f.date_creation
                      ).toLocaleDateString()
                    : "-"}
                </div>

              </div>
            );
          }
        )}

      </div>

      {/* DESKTOP */}
      <div className="hidden md:block overflow-x-auto bg-white rounded-2xl shadow">

        <table className="w-full text-sm">

          <thead className="bg-gray-900 text-white">

            <tr>

              <th className="p-3 text-left">
                Date
              </th>

              <th className="p-3 text-left">
                Appartement
              </th>

              <th className="p-3 text-left">
                Facture
              </th>

              <th className="p-3 text-center">
                Statut
              </th>

              <th className="p-3 text-right">
                Montant
              </th>

              <th className="p-3 text-left">
                Client
              </th>

            </tr>

          </thead>

          <tbody>

            {paginated.map(
              (f) => {

                const montant =
                  Number(
                    f.montant || 0
                  );

                const totalPaye =
                  Number(
                    f.total_paye ||
                      0
                  );

                const reste =
                  Number(
                    f.reste ??
                      (montant -
                        totalPaye)
                  );

                const isPaid =
                  reste <= 0;

                return (
                  <tr
                    key={f.id}
                    onClick={() =>
                      openFacture(
                        f.id
                      )
                    }
                    className="border-t hover:bg-gray-50 cursor-pointer transition"
                  >

                    <td className="p-3 whitespace-nowrap">
                      {f.date_creation
                        ? new Date(
                            f.date_creation
                          ).toLocaleDateString()
                        : "-"}
                    </td>

                    <td className="p-3">
                      {
                        f.appartement
                      }
                    </td>

                    <td className="p-3 text-blue-600 font-semibold">
                      {f.numero}
                    </td>

                    <td className="p-3 text-center">

                      <span
                        className={`px-2 py-1 rounded text-xs ${
                          isPaid
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {isPaid
                          ? "PAYÉ"
                          : "RESTE"}
                      </span>

                    </td>

                    <td className="p-3 text-right font-bold whitespace-nowrap">
                      {montant.toLocaleString()} $
                    </td>

                    <td className="p-3">
                      {f.nom}{" "}
                      {
                        f.prenom
                      }
                    </td>

                  </tr>
                );
              }
            )}

          </tbody>

        </table>

      </div>

      {/* PAGINATION */}
      <div className="flex justify-center gap-2 flex-wrap">

        {Array.from(
          {
            length:
              totalPages
          },
          (_, i) => (
            <button
              key={i}
              onClick={() =>
                setPage(i + 1)
              }
              className={`px-4 py-2 rounded-xl text-sm transition ${
                page ===
                i + 1
                  ? "bg-blue-600 text-white"
                  : "bg-white hover:bg-gray-100"
              }`}
            >
              {i + 1}
            </button>
          )
        )}

      </div>

    </div>
  );
}